import React from 'react';
import { chakra, ButtonProps } from '@chakra-ui/react';
import { LuX } from 'react-icons/lu';

export interface OmniCloseButtonProps extends ButtonProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'solid' | 'ghost';
}

export const OmniCloseButton = React.forwardRef<
  HTMLButtonElement,
  OmniCloseButtonProps
>(function OmniCloseButton(props, ref) {
  const { children, size = 'md', variant = 'ghost', ...rest } = props;

  return (
    <chakra.button
      ref={ref}
      recipe={{ key: 'omni-close-button', size, variant }}
      aria-label="Close"
      {...rest}
    >
      {children || <LuX />}
    </chakra.button>
  );
});

export default OmniCloseButton;
